import { render, staticRenderFns } from "./PDFImport.vue?vue&type=template&id=e074241c"
import script from "./PDFImport.vue?vue&type=script&lang=js"
export * from "./PDFImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports